const GridIcon = ({ color }: any) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' x='0px' y='0px' viewBox='0 0 512.001 512.001'>
      <path
        d='M511.78,171.836V56.973c0-31.354-25.508-56.863-56.863-56.863H56.863C25.508,0.11,0,25.619,0,56.973v398.055
       c0,31.354,25.508,56.863,56.863,56.863h398.055c31.354,0,56.863-25.508,56.863-56.863V176.985
       c0.145-0.837,0.221-1.697,0.221-2.575S511.925,172.673,511.78,171.836z M348.436,30.094h106.482
       c14.821,0,26.879,12.058,26.879,26.879v102.446H348.436V30.094z M155.336,481.907H56.863c-14.822,0-26.879-12.058-26.879-26.879
       V352.519h125.352V481.907z M155.336,322.535H29.984V189.403h125.352V322.535z M155.337,159.419H29.984V56.973
       c0-14.821,12.057-26.879,26.879-26.879h98.474V159.419z M318.452,481.907H185.319V352.519h133.133V481.907z M318.452,322.535
       H185.319V189.403h133.133V322.535z M318.452,159.419H185.319V30.094h133.133V159.419z M481.797,455.028
       c0,14.821-12.058,26.879-26.879,26.879H348.436V352.519h133.361V455.028z M481.797,322.535H348.436V189.403h133.361V322.535z'
      />
    </svg>
  )
}

export default GridIcon
